import React from "react";

import { useDispatch, useSelector } from "react-redux";
import AiAgent from "./AiAgent";
import { useNavigate } from "react-router-dom";
import { saveSlugName } from "../../redux/slices/CreateAgentSlice";
import {getImages} from '../../utills/lib'; // Ensure this utility function is correctly imported

function LoadAgentMap() {
  const { agentList } = useSelector((state) => state.LoadAIAgentsSlice);
  console.log('agentList===>123',agentList)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const AgentList = ({ agentList }) => {
    return (
      <div>
        {agentList.map((field) => {
            console.log('field',field)
          return (
            <AiAgent
              onClick={()=>{
                dispatch(saveSlugName(field.slug))
                navigate("/NewAgentViewerScreen", { state: { field, statusDefault: "Completed" } });

              }}
              backgroundColor={field.backgroundColor}
              image={getImages(field?.ai_agent)}
              title={field.name}
              subtitle={field.slug}
              className="agent-container"
            />
          );
        })}
      </div>
    );
  };
  return (
    <div>
      <AgentList agentList={agentList}></AgentList>
    </div>
  );
}

export default LoadAgentMap;
